import AdUtils from '../../../../shared/utils/ads';
import ChannelView from '@shared/types/enums/channelView';
import FlavourConfig from '../../../../shared/config/flavours';
import Focus from '@shared/types/enums/focus';
import Modals from '../../../../shared/types/enums/modals';
import Pages from '@pages';
import Sections from '../../../../shared/types/enums/sections';
import Storage from '@storage';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import { purgeEvents } from '../../../../shared/store/slices/events.slice';
import { pushRoute } from '../../../../shared/store/slices/router.slice';
import { setChannel } from '@shared/store/slices/channels.slice';
import { store } from '../../../../shared/store/store';

const MenuData = {
  Initial: {
    action: () => {
      store.dispatch(
        pushRoute({
          route: { Page: Pages.INITIAL, overwrite: true },
        })
      );
    },
    ad: () => AdUtils.getSource(Sections.GUIDE_TV),
    text: 'COMPONENTS.MENU.HOME',
  },
  MySpace: {
    action: () => {
      const { user } = store.getState();
      store.dispatch(
        pushRoute({
          route: { Page: Pages.MY_SPACE, overwrite: true },
          params: user.isAnonymous
            ? {
                current: {
                  message: TranslationManager.get('PAGES.MY_SPACE.LOGIN'),
                  modal: Modals.ANONYMOUS_GENERIC,
                },
              }
            : {},
        })
      );
    },
    ad: () => {
      const { user } = store.getState();
      if (user.isAnonymous) {
        return '';
      } else {
        return AdUtils.getSource(Sections.MY_RECORDINGS);
      }
    },
    text: 'COMPONENTS.MENU.MY_SPACE',
  },
  Recordings: {
    action: () => {
      const { user } = store.getState();
      store.dispatch(
        pushRoute({
          route: { Page: Pages.RECORDINGS, overwrite: true },
          params: user.isAnonymous
            ? {
                current: {
                  message: TranslationManager.get('PAGES.RECORDINGS.LOGIN'),
                  modal: Modals.ANONYMOUS_GENERIC,
                },
              }
            : {},
        })
      );
    },
    ad: () => {
      const { user } = store.getState();
      if (user.isAnonymous) {
        return '';
      } else {
        return AdUtils.getSource(Sections.MY_RECORDINGS);
      }
    },
    text: 'COMPONENTS.MENU.RECORDINGS',
  },
  Channels: {
    action: () => {
      const { channels } = store.getState();
      store.dispatch(purgeEvents());
      store.dispatch(setChannel(channels.channelsData?.[0] || 1));
      const viewSelected = Storage.get('userChannelViewSelection');
      if (viewSelected) {
        if (parseInt(viewSelected) === ChannelView.Classic) {
          store.dispatch(
            pushRoute({
              route: { Page: Pages.CLASSIC_CHANNEL, overwrite: true },
            })
          );
        } else {
          store.dispatch(
            pushRoute({
              route: { Page: Pages.CHANNELS_MAIN, overwrite: true },
              params: {
                current: {
                  previousFocus: Focus.MENU,
                },
              },
            })
          );
        }
      } else {
        store.dispatch(
          pushRoute({
            route: {
              Page: Pages.CHANNELS_CHOICE,
              overwrite: true,
            },
          })
        );
      }
    },
    ad: () => AdUtils.getSource(Sections.CHANNELS_MAIN),
    text: 'COMPONENTS.MENU.CHANNELS',
  },
  Movies: {
    action: () => {
      store.dispatch(
        pushRoute({
          route: { Page: Pages.MOVIES, overwrite: true },
        })
      );
    },
    ad: () => AdUtils.getSource(Sections.MOVIES_U7D),
    text: 'COMPONENTS.MENU.MOVIES',
  },
  Series: {
    action: () => {
      store.dispatch(
        pushRoute({
          route: { Page: Pages.SERIES_U7D, overwrite: true },
        })
      );
    },
    ad: () => AdUtils.getSource(Sections.SERIES_U7D),
    text: FlavourConfig.capabilities.u7d
      ? 'COMPONENTS.MENU.U7D_SERIES'
      : 'COMPONENTS.MENU.SERIES',
  },
  Shows: {
    action: () => {
      store.dispatch(
        pushRoute({
          route: { Page: Pages.SHOWS_U7D, overwrite: true },
        })
      );
    },
    ad: () => AdUtils.getSource(Sections.SHOWS_U7D),
    text: FlavourConfig.capabilities.u7d
      ? 'COMPONENTS.MENU.U7D_PROGRAMMES'
      : 'COMPONENTS.MENU.PROGRAMMES',
  },
  MoreContent: {
    action: () => {
      store.dispatch(
        pushRoute({
          route: { Page: Pages.MORE_CONTENT, overwrite: true },
        })
      );
    },
    ad: () => AdUtils.getSource(Sections.MORE_CONTENT),
    text: 'COMPONENTS.MENU.MORE_CONTENT',
  },
  Settings: {
    action: () => {
      store.dispatch(
        pushRoute({
          route: { Page: Pages.SETTINGS, overwrite: true },
        })
      );
    },
    ad: () => '',
    check: Pages.SETTINGS,
    text: 'COMPONENTS.MENU.SETTINGS',
  },
  Exit: {
    action: () => {
      store.dispatch(
        pushRoute({
          route: { Page: Pages.EXIT, overwrite: true },
        })
      );
    },
    ad: () => '',
    text: 'COMPONENTS.MENU.EXIT',
  },
};

export default MenuData;
